<template>
  <header
    v-bind="$attrs"
    class="vs-navbar"
    :class="[
      `vs-navbar-${type}`,
      `vs-navbar-color-${color}`,
      { collapse },
    ]"
    :style="navbarStyle"
  >
    <div class="vs-navbar--header">
      <button
        type="button"
        class="vs-navbar--btn-responsive"
        :class="{ 'active-menu': activeMenuResponsive }"
        @click="activeMenuResponsive = !activeMenuResponsive"
      >
        <span class="btn-responsive-line line--1" />
        <span class="btn-responsive-line line--2" />
        <span class="btn-responsive-line line--3" />
      </button>
      <slot name="title" />
    </div>
    <div
      class="vs-con-items"
      :class="{ activeMenuResponsive: activeMenuResponsive }"
    >
      <slot />
    </div>
  </header>
</template>

<script>
const NAMED_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
  "transparent",
];

export default {
  name: "VsNavbar",
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    type: {
      type: String,
      default: null,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "transparent",
    },
    activeTextColor: {
      type: String,
      default: "primary",
    },
    textColor: {
      type: String,
      default: "rgb(40,40,40)",
    },
  },
  emits: ["update:modelValue", "input"],
  data() {
    return {
      activeMenuResponsive: false,
    };
  },
  computed: {
    navbarStyle() {
      if (NAMED_COLORS.includes(this.color)) return null;
      return {
        background: this.color,
      };
    },
  },
  methods: {
    changeIndex(index) {
      this.$emit("update:modelValue", index);
      this.$emit("input", index);
    },
  },
};
</script>
